import React from 'react';
import PropTypes from 'prop-types';
import { getLinkTag } from '../../utils';
import Badge from '../Badge';

import styles from './media.module.scss';

function MediaCard(props) {
  const {
    badge,
    image,
    link,
    title,
  } = props;

  const linkInformation = getLinkTag(link);
  const Tag = linkInformation.tag || 'div';
  const tagProps = linkInformation.tagProps || {};

  const mediaCardContent = (
    <div className={styles.card}>
      <div className={styles.imgContainer}>
        {image && (
          <img className={styles.image} src={image.file.url} alt={title} />
        )}
        {badge && (
          <div className={styles.badgeWrapper}>
            <Badge {...badge} />
          </div>
        )}
      </div>
      {/* {title && <h4 className={styles.title}>{title}</h4>} */}
    </div>
  );

  return (
    <>
      {(link
        ? (
          <Tag {...tagProps} className={styles.link}>
            {mediaCardContent}
          </Tag>
        )
        : mediaCardContent
      )}
    </>
  );
}

export default MediaCard;

MediaCard.propTypes = {
  badge: PropTypes.shape(Badge.proptypes),
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  link: PropTypes.string,
  title: PropTypes.string,
};

MediaCard.defaultProps = {
  badge: Badge.defaultProps,
  image: { file: { url: '' } },
  link: '',
  title: '',
};
